import React from 'react';
import './PlaylistRow.scss';

export default function PlaylistRow({
  title,
  meta,
  imageUrl = "data:image/svg+xml, %3Csvg className='PlaylistRow__artwork' width='64' height='64' viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath fill='%23BDBDBD' fillRule='evenodd' d='M28.5 25.159v10.899A3.485 3.485 0 0026 35c-1.93 0-3.5 1.57-3.5 3.5S24.07 42 26 42s3.5-1.57 3.5-3.5V25.969l11-2.339v10.178A3.485 3.485 0 0038 32.75c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5V22.395l-13 2.764zM26 41a2.503 2.503 0 01-2.5-2.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5S27.378 41 26 41zm12-2.25a2.503 2.503 0 01-2.5-2.5c0-1.379 1.122-2.5 2.5-2.5s2.5 1.121 2.5 2.5c0 1.378-1.122 2.5-2.5 2.5z' clipRule='evenodd' /%3E%3C/svg%3E"
}) {
  return (
    <div className="PlaylistRow">
      <div
        className="PlaylistRow__artwork"
        style={{
          backgroundImage: `url("${imageUrl}")`
        }}
      />
      <div className="PlaylistRow__group">
        <div className="PlaylistRow__title">{title}</div>
        <div className="PlaylistRow__meta">{meta}</div>
      </div>
    </div>
  );
}
